export class AddOutstandingModel {
    value:	number;
    companyId:	number;
    period: number;
}
